import React, { Component } from 'react';

import classes from './EmailRegister.module.css';
import GenderStep from './Steps/GenderStep/GenderStep';
import UsernameStep from './Steps/UsernameStep/UsernameStep';
import LocationStep from './Steps/LocationStep/LocationStep';
import AgeStep from './Steps/AgeStep/AgeStep';
import EmailAndPasswordStep from './Steps/EmailAndPasswordStep/EmailAndPasswordStep';
import { isIOS, isChrome } from 'react-device-detect';

export default class EmailRegister extends Component {
  state = {
    hideHeader: false,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  onFocus = () => {
    if (!this.props.isLandscape) {
      this.setState({ hideHeader: true });
    }
  };

  onBlur = () => {
    if (!this.props.isLandscape) {
      this.setState({ hideHeader: false });
    }
  };

  render() {
    const { step } = this.props;
    let activeStep;

    if (step === 1) {
      activeStep = (
        <GenderStep
          genderApiConfigDataLodaded={this.props.genderApiConfigDataLodaded}
          isGenderUrlPreselected={
            this.gender && this.seeking
              ? this.props.isGenderUrlPreselected
              : false
          }
          getConfig={this.props.getConfig}
          gender={this.props.gender || 1}
          seeking={this.props.seeking || 2}
          genderAndSeekingSelectedValue={
            this.props.genderAndSeekingSelectedValue
          }
          goToStep={this.props.goToStep}
          setGenderAndSeeking={this.props.setGenderAndSeeking}
        />
      );
    } else if (step === 2) {
      activeStep = (
        <LocationStep
          isLandscape={this.props.isLandscape}
          goToStep={this.props.goToStep}
          setLocation={this.props.setLocation}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          hideHeader={this.state.hideHeader}
          searchLocation={this.props.searchLocation}
          nbsApiSearchLocation={this.props.nbsApiSearchLocation}
          location={this.props.location}
        />
      );
    } else if (step === 3) {
      activeStep = (
        <AgeStep
          isLandscape={this.props.isLandscape}
          goToStep={this.props.goToStep}
          age={this.props.age}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          hideHeader={this.state.hideHeader}
          minAge={this.props.minAge}
          maxAge={this.props.maxAge}
          setAge={this.props.setAge}
        />
      );
    } else if (step === 4) {
      activeStep = (
        <UsernameStep
          isLandscape={this.props.isLandscape}
          username={this.props.username}
          setUsername={this.props.setUsername}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          hideHeader={this.state.hideHeader}
          checkUsername={this.props.checkUsername}
          nbsApiCheckUsername={this.props.nbsApiCheckUsername}
          goToStep={this.props.goToStep}
        />
      );
    } else if (step === 5) {
      activeStep = (
        <EmailAndPasswordStep
          email={this.props.email}
          password={this.props.password}
          setEmail={this.props.setEmail}
          setPassword={this.props.setPassword}
          isLandscape={this.props.isLandscape}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          hideHeader={this.state.hideHeader}
          goToStep={this.props.goToStep}
          emailRegister={this.props.emailRegister}
          emailLogin={this.props.emailLogin}
          createAccount={this.props.createAccount}
          transCoregLookup={this.props.transCoregLookup}
          getTransCoreg={this.props.getTransCoreg}
          isTransCoregOfferChecked={this.props.isTransCoregOfferChecked}
          toggleTransCoregOffer={this.props.toggleTransCoregOffer}
          getConfig={this.props.getConfig}
          transCoregText={this.props.transCoregText}
          showTransCoregCheckbox={this.props.showTransCoregCheckbox}
          setTransCoreg={this.props.setTransCoreg}
          country={this.props.country}
        />
      );
    }

    return (
      <div
        className={classes.EmailRegister}
        style={{ paddingBottom: isIOS && isChrome ? '6rem' : '0rem' }}
      >
        {activeStep}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/EmailRegister/EmailRegister.js